import {renderElement} from "./utils/common";

const CountAction = {
  PLUS: `PLUS`,
  MINUS: `MINUS`,
};

export const subscribers = () => {
  const subscribersContainersElements = document.querySelectorAll(`.js-subscriber`);

  const getCurrentSubscriberTemplate = (
    value,
    src,
    name,
  ) => `<li class="workers__item js-subscriber-item" data-value="${value}" data-name="${name}" tabindex="0">
    <img src="${src}" alt="Аватар ${name}" class="workers__icon" width="28" height="28">
  </li>`;

  if (subscribersContainersElements.length) {
    subscribersContainersElements.forEach((subscribersContainer) => {
      const currentSubscribersListElement = subscribersContainer.querySelector(`.js-subscriber-list-current`);
      const subscribersCountElement = subscribersContainer.querySelector(`.js-subscriber-count`);
      const formElement = subscribersContainer.closest(`.js-create-form`);

      const SUBSCRIBE_FORM_NAME = subscribersContainer.dataset.inputName;

      const subscribeUser = (subscriberElement, value) => {
        const name = subscriberElement.dataset.name;
        const imgSrc = subscriberElement.querySelector(`img`).src;

        renderElement(currentSubscribersListElement, getCurrentSubscriberTemplate(value, imgSrc, name));
        setCount(CountAction.PLUS);
      };

      const unSubscribeUser = (subscriberElement) => {
        const value = subscriberElement.dataset.value;

        Array.from(formElement[SUBSCRIBE_FORM_NAME]).filter((input) => input.value === value)[0].checked = false;

        subscriberElement.remove();
        setCount(CountAction.MINUS);
      };

      const setCount = (action) => {
        let currentCount = +subscribersCountElement.textContent;

        if (action === CountAction.PLUS) {
          currentCount++;
        } else {
          currentCount--;
        }

        subscribersCountElement.textContent = currentCount;
      };

      const onCurrentSubscribersListClick = (evt) => {
        if (evt.target.classList.contains(`js-subscriber-item`) || evt.target.closest(`.js-subscriber-item`)) {
          const self = evt.target.classList.contains(`js-subscriber-item`) ? evt.target : evt.target.closest(`.js-subscriber-item`);

          unSubscribeUser(self);
        }
      };

      const onFormElementChange = (evt) => {
        if (evt.target.name === SUBSCRIBE_FORM_NAME) {
          const self = evt.target;
          const workerElement = self.nextElementSibling;

          if (workerElement) {
            subscribeUser(workerElement, self.value);
          }
        }
      };

      currentSubscribersListElement.addEventListener(`click`, onCurrentSubscribersListClick);
      formElement.addEventListener(`change`, onFormElementChange);
    });
  }
};
